export interface PriceQuote {
  timestamp: number
  price: number
}

export enum TimeFrame {
  FIVE_MINUTES,
  ONE_HOUR,
  ONE_DAY,
}
